import { GlassBox } from 'components/glassBox/GlassBox';

interface ReferralCountdownPartProps {
  value: string | number;
  label: string;
  valueClasses: string[];
  labelsClasses: string[];
  containerClasses: string[];
  valueWrapperClasses?: string[];
}

export const ReferralCountdownPart = ({
  value,
  label,
  valueClasses,
  labelsClasses,
  containerClasses,
  valueWrapperClasses = [],
}: ReferralCountdownPartProps) => {
  return (
    <div className={containerClasses.join(' ')}>
      <GlassBox
        gradient="linear-gradient(to bottom right, #2D5EFF 0%, rgba(45, 94, 255, 0.2) 100%)"
        borderWidth="1px"
        className={valueWrapperClasses.join(' ')}
        backgroundOpacity={0.15}
        blurAmount="25px"
      >
        <div className={`${valueClasses.join(' ')} tw-relative tw-z-10 !tw-bg-transparent`}>{value || 0}</div>
      </GlassBox>
      <div className={labelsClasses.join(' ')}>{label}</div>
    </div>
  );
};
